<template>
    <div class="caseFiji">
      <Helmet>
        <title>Case Fiji - inte-QT</title>
        <meta name="title" content="Case Fiji - inte-QT" />
        <meta name="description" content="Connecting a BFSI company in the far East of the World, Fiji. Explore how inte-QT addressed connectivity challenges." />
        <meta name="keywords" content="Fiji, BFSI, connectivity, network solutions, inte-QT, case study" />
        <link rel="canonical" href="https://inte-qt.com/cases/fiji" />
      </Helmet>
      <img
        src="/images/diCPBGP.jpg"
        alt="Connectivity challenges in Fiji's banking sector"
        class="banner-img banner-img__black"
      />
      <h1 class="caseFiji2__title text-center">
        Navigating Connectivity Challenges in Fiji’s Banking Sector
      </h1>
      <div class="caseFiji2__div"></div>
  
      <div class="container-fluid caseFiji">
        <div class="container">
          <div class="caseFiji2__width my-5">
            <div class="caseFiji2__space m-4">
              <img
                src="/images/847uR6R.png"
                alt="Technology challenges in banking"
                class="caseFiji2__icon mx-3"
              />
              <h2 class="pt-4">Challenges:</h2>
            </div>
            <ul>
              <li>Faster Deployment and Migration</li>
              <li class="mt-2">Secure Access to Cloud Applications</li>
              <li class="mt-2">Integration of Remote Offices with the Mainland</li>
              <li class="mt-2">Adverse Climate Conditions</li>
              <li class="mt-2">Unavailability of Required Infrastructure</li>
            </ul>
          </div>
  
          <div class="caseFiji2__width my-5 caseFiji2__margin">
            <div class="caseFiji2__space m-4">
              <img
                src="/images/4s6vXof.png"
                alt="Wireless connectivity solution"
                class="caseFiji2__icon mx-3"
              />
              <h2 class="pt-4">Solution:</h2>
            </div>
            <ul>
              <li>
                Robust and Reliable Network Deployment as part of inte-Qt
                Dedicated Line Service
              </li>
              <li class="mt-2">
                Flawless Installation of inte-Qt Dedicated Line Service ensured
                seamless go-live of multiple locations.
              </li>
              <li class="mt-2">
                24x7 Network Assurance with inte-Qt Dedicated Line Service enabled
                real-time resolution of customer operations.
              </li>
            </ul>
          </div>
  
          <div class="caseFiji2__width my-5">
            <div class="caseFiji2__space m-4">
              <img
                src="/images/55CYPwa.png"
                alt="Successful outcomes"
                class="caseFiji2__icon mx-3"
              />
              <h2 class="pt-4">Outcomes:</h2>
            </div>
            <ul>
              <li>Sustainable and seamless operations for the user.</li>
              <li class="mt-2">
                Significant savings for the customer and overall service effectiveness.
              </li>
              <li class="mt-2">Exceeding customer expectations.</li>
            </ul>
          </div>
  
          <h2 class="my-5">Challenge:</h2>
          <p align="justify">
            At inte-QT, we believe that challenges make us stronger and better with each delivery.
          </p>
          <p align="justify">
            The customer required connectivity for a reputed bank located in Fiji, a country of islands where the sun rises as it sets in the West.
          </p>
          <img
            src="/images/Dvbfhyz.jpg"
            alt="Beautiful beach in Fiji"
            class="caseFiji2__textimg caseFiji2__right m-3"
          />
          <p align="justify">
            The customer and end-user sought quick deployment and installation of links due to the critical nature of banking operations. Timely delivery was essential given the extensive requirements across the country's geography.
          </p>
          <p align="justify">
            User operations had restricted access, making secure service paramount.
          </p>
          <p align="justify">
            Being in a seismic zone prone to natural calamities like cyclones, accessing sites for connectivity deployment proved difficult.
          </p>
          <p align="justify">
            Challenges included infrastructure shortages, timely equipment availability, and the need to avoid disruptions to existing services.
          </p>
          <p align="justify">
            Additionally, commercial terms needed to be aggressive to ensure savings.
          </p>
  
          <h2 class="my-5">Solution:</h2>
          <p align="justify">
            Deeper customer engagement has always been part of the culture at Bits and Byte Global. Our customer appreciates the support we provide, allowing for open communication of requirements and concerns.
          </p>
          <img
            src="/images/4O7Reay.jpg"
            alt="Technology implementation"
            class="caseFiji2__textimg caseFiji2__left m-3"
          />
          <p align="justify">
            We engaged all relevant interfaces to address the customer's needs. Local partners and service providers were informed of the critical nature of the service.
          </p>
          <p align="justify">
            Logistics were aligned to ensure installations were completed without delays. Relevant teams ensured services went live smoothly.
          </p>
          <p align="justify">
            The network design focused on safety and security of user data with cloud service providers, including necessary redundancies to mitigate geographical vulnerabilities.
          </p>
          <p align="justify">
            inte-Qt Dedicated Line service offers commitment across all fronts, from bandwidth to 24x7 network support. Rigorous tests were conducted before declaring services ready.
          </p>
  
          <h2 class="my-5">Outcome:</h2>
          <p align="justify">
            Collaborative efforts led to timely delivery of services, meeting all quality parameters. Sustainable operations were achieved, with various links live and connected to the cloud.
          </p>
          <p align="justify">
            The execution resulted in significant monetary savings, estimated at around 38%, without compromising service quality. The precise design improved operational effectiveness through prompt monitoring.
          </p>
          <p align="justify">
            The customer and end-user appreciated inte-Qt's Dedicated Line service and network support, yielding both tangible benefits and improved service parameters.
          </p>
          <img
            src="/images/7fH1NGe.jpg"
            alt="Satisfied customers"
            class="caseFiji2__lastimg rounded"
          />
  
          <div class="cases__box">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <h2 class="cases__companyName mx-3">{{ cases[2].title }}</h2>
                <p class="cases__text m-3" align="justify">
                  {{ cases[2].p5 }}
                </p>
                <div class="text-end mx-3">
                  <DinamicLink url="/cases/argentina" name="Read more" />
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <img :src="cases[2].img" alt="Argentina case" class="cases__img" />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";
  import DinamicLink from "@/components/DinamicLink";
  import GetInTouch from "@/components/GetInTouch";
  import cases from "@/data/casesInfo.json";
  import { Helmet } from "vue-helmet";
  
  export default {
    components: {
      DinamicLink,
      GetInTouch,
      Helmet,
    },
    setup() {
      const casesData = ref(cases);
  
      onMounted(() => {
        window.scroll(0, 0);
      });
  
      return {
        cases: casesData,
      };
    },
  };
  </script>
  
  <style scoped>
  .caseFiji {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
   ul {
    margin-top: 0;
    margin-bottom: 1rem;
    text-align: -webkit-left;
  
  }
  
  .caseFiji__aux {
    padding: 5rem 12rem;
  }
  
  .caseFiji__space {
    margin-top: 6rem;
  }

  caseFiji {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
  .caseFiji2__width {
    margin: 1rem;
  }
  
  .caseFiji2__space {
    display: flex;
    align-items: center;
  }
  
  .caseFiji2__icon {
    max-width: 50px;
    max-height: 50px;
  }
  
  .caseFiji2__textimg {
    width: 100%;
    margin: 1rem;
  }
  
  .banner-img {
    width: 100%;
  }
  
  .banner-img__black {
    background-color: black;
  }
  
  .banner-img__header {
    position: absolute;
    top: 45vh;
    left: 50vw;
    transform: translateX(-50%) translateY(-50%);
    font-size: 4rem;
    font-weight: bold;
    color: white;
    text-align: center;
  }
  
  ul {
    list-style-type: disc;
    padding-left: 2rem;
  }
  
  ul li {
    margin-bottom: 0.5rem;
  }
  
  .cases__box {
    margin-top: 3rem;
  }
  
  .cases__companyName {
    font-size: 2rem;
    font-weight: bold;
  }
  
  .cases__text {
    text-align: justify;
    font-size: 1.2rem;
  }
  
  .cases__img {
    max-width: 100%;
  }
  
  .text-end {
    text-align: right;
  }
  
  .mx-3 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  
  @media screen and (max-width: 768px) {
    .banner-img__header {
      font-size: 2.5rem;
      top: 30vh;
    }
  }
  
  @media (max-width: 768px) {
    .caseFiji {
      line-height: 1.2;
      margin-top: 0rem;
    }
  
    .caseFiji__title {
      margin: 1rem;
    }
  
    .caseFiji__aux {
      padding: 1rem;
    }
  }
  .caseFiji2 {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
  .caseFiji2__title {
    position: absolute;
    width: 40vw;
    top: 45vh;
    left: 55vw;
    line-height: 1.5;
    font-size: 4rem;
    font-weight: bold;
    color: white;
  }
  
  .caseFiji2__icon {
    width: 75px;
  }
  
  .caseFiji2__textimg {
    width: 500px;
  }
  
  .caseFiji2__lastimg {
    width: 100%;
  }
  
  .caseFiji2__space {
    display: flex;
  }
  
  .caseFiji2__width {
    width: 40vw;
  }
  
  .caseFiji2__right {
    float: right;
  }
  
  .caseFiji2__left {
    float: left;
  }
  
  .caseFiji2__margin {
    margin-left: 45%;
  }
  
  @media (max-width: 768px) {
    .caseFiji2__title {
      font-size: 3rem;
      top: 30vh;
      left: 55vw;
    }
  
    .caseFiji2__icon {
      width: 60px;
    }
  
    .caseFiji2__textimg {
      width: 80vw;
    }
  
    .caseFiji2__width {
      width: auto;
    }
  
    .caseFiji2__margin {
      margin-left: 53%;
    }
  }
  
  @media (max-width: 480px) {
    .caseFiji2__title {
      font-size: 1.5rem;
      top: 12vh;
      left: 5vw;
      width: 90vw;
    }
  
    .caseFiji2__icon {
      width: 50px;
    }
  }
  </style>
  